import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  BusinessInformationHelp,
  AttachmentsHelp,
  CommoditiesHelp,
  AccessAndCapacityHelp,
  LocationsHelp,
} from "./ReloadYardHelpComponents";

const useStyles = makeStyles(() => ({
  icon: {
    verticalAlign: "middle",
    display: "inline-flex",
  },
}));

export const ReloadYardHelp = (props) => {
  const classes = useStyles();
  const tabNames = props?.location.pathname.split("/");
  const tab = tabNames?.length > 3 ? tabNames[3] : "";

  switch (tab) {
    case "":
      return <BusinessInformationHelp classes={classes} />;
    case "settings":
      return <AttachmentsHelp classes={classes} />;
    case "commodities":
      return <CommoditiesHelp classes={classes} />;
    case "capabilities":
      return <AccessAndCapacityHelp classes={classes} />;
    case "layout":
      return <LocationsHelp classes={classes} />;
    default:
      return null;
  }
};
